import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";

export const INTRO = 1.9;
export const LOGO_BLUE = "#141c5d";

export const IntroSplash = ({ targetRef, onDone }) => {
  const [target, setTarget] = useState(null);
  const [gone, setGone] = useState(false);
  const finish = useCallback(() => {
    setGone(true);
    onDone?.();
  }, [onDone]);

  useEffect(() => {
    const t = setTimeout(() => {
      const r = targetRef.current?.getBoundingClientRect();
      if (r) setTarget({ left: r.left, top: r.top, width: r.width });
      else finish();
    }, 1100);
    return () => clearTimeout(t);
  }, [targetRef, finish]);

  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const bigW = Math.min(vw * 0.78, 820);
  const bigH = bigW * (227 / 740);
  const start = { left: (vw - bigW) / 2, top: (vh - bigH) / 2 - 20, width: bigW };

  if (gone) return null;

  return createPortal(
        <div className="fixed inset-0 z-[300] pointer-events-none" data-testid="intro-splash">
          <motion.div
            className="absolute inset-0"
            style={{ background: `radial-gradient(ellipse at 50% 45%, #1f2f86 0%, ${LOGO_BLUE} 55%, #0d1240 100%)` }}
            initial={{ opacity: 1 }}
            animate={{ opacity: target ? 0 : 1 }}
            transition={{ duration: 0.9, delay: target ? 0.25 : 0, ease: [0.4, 0, 0.2, 1] }}
          />
          <motion.img
            src="/banner-logo.png"
            alt=""
            className="absolute"
            style={{ filter: "drop-shadow(0 20px 60px rgba(0,0,0,0.5))" }}
            initial={{ ...start, opacity: 0, scale: 0.9 }}
            animate={target ? { ...target, opacity: 1, scale: 1 } : { ...start, opacity: 1, scale: 1 }}
            transition={target ? { duration: 0.95, ease: [0.76, 0, 0.24, 1] } : { duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            onAnimationComplete={() => target && finish()}
          />
          {!target && (
            <motion.div
              className="absolute left-1/2 -translate-x-1/2 font-mono text-[11px] uppercase tracking-[0.35em] text-white/60"
              style={{ top: start.top + bigH + 36 }}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              Bendigo · Est. Flora Hill
            </motion.div>
          )}
        </div>,
    document.body
  );
};
